export function startStencilSprayEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const canvas = imgPanelEl.querySelector('canvas.spray-overspray-canvas');
  if (!canvas) return () => {};

  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const resize = () => {
    const w = imgPanelEl.offsetWidth || 0;
    const h = imgPanelEl.offsetHeight || 0;
    if (w <= 0 || h <= 0) return;
    canvas.width = w;
    canvas.height = h;
  };

  resize();

  const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(resize) : null;
  if (observer) observer.observe(imgPanelEl);

  const particles = [];
  const particleCount = 520;
  for (let i = 0; i < particleCount; i++) {
    particles.push({
      x: Math.random(),
      y: Math.random(),
      r: Math.random() * 2.5 + 0.5,
      opacity: Math.random() * 0.18 + 0.05,
      delay: Math.random() * 2400,
      drift: (Math.random() - 0.5) * 0.08
    });
  }

  const startTime = Date.now();
  let rafId = 0;

  const draw = () => {
    const w = canvas.width;
    const h = canvas.height;
    if (w <= 0 || h <= 0) {
      rafId = requestAnimationFrame(draw);
      return;
    }

    ctx.clearRect(0, 0, w, h);

    const elapsed = Date.now() - startTime;

    // Bright overspray speckle so it reads as spray paint (not soot)
    // Keep it subtle but visible by using yellow with low alpha.
    ctx.globalCompositeOperation = 'source-over';

    particles.forEach((p) => {
      if (elapsed < p.delay) return;
      const progress = Math.min(1, (elapsed - p.delay) / 500);
      const dx = Math.sin((elapsed / 1000) * 1.8 + p.y * 12) * p.drift;
      const x = (p.x + dx + 1) % 1;
      ctx.fillStyle = `rgba(255, 255, 0, ${p.opacity * progress})`;
      ctx.beginPath();
      ctx.arc(x * w, p.y * h, p.r, 0, Math.PI * 2);
      ctx.fill();
    });

    if (elapsed < 6000) {
      rafId = requestAnimationFrame(draw);
    }
  };

  rafId = requestAnimationFrame(draw);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    if (observer) observer.disconnect();
  };
}
